import type { IImage } from "@components/types/media";
import type React from "react";

import { AspectRatio } from "@components/core/AspectRatio";
import { Image } from "@components/core/Image";
import { isValidImage } from "@ui/lib/image";
import { cn } from "@ui/lib/utils";

interface IProductIconProps {
  className?: string;
  icon?: IImage | React.ReactNode | null;
}

const isReactNode = (icon: IImage | React.ReactNode | null | undefined): icon is React.ReactNode => {
  return icon !== null && icon !== undefined && typeof icon === "object" && ("$$typeof" in icon || "type" in icon);
};

const ProductIcon = ({ icon, className }: IProductIconProps) => {
  const wrapperClassName = cn(
    "inline-flex w-40 items-center justify-center overflow-hidden rounded-full bg-default p-8",
    className,
  );

  if (isReactNode(icon)) {
    return (
      <AspectRatio border className={wrapperClassName} ratio='1x1'>
        <div className='flex h-full w-full items-center justify-center'>{icon}</div>
      </AspectRatio>
    );
  }

  return (
    isValidImage(icon) && (
      <AspectRatio border className={wrapperClassName} ratio='1x1'>
        <Image className='h-auto w-full' {...icon} sizes='40px' />
      </AspectRatio>
    )
  );
};

ProductIcon.displayName = "ProductIcon";

export { ProductIcon };
